import React from 'react';
import { Switch } from 'react-router-dom';

// Componente para deixar rotas privadas
import Route from './Route';

// Importando paginas
import Login from '~/pages/Login';
import Forgot from '~/pages/Forgot';
import Password from '~/pages/Password';
import Dashboard from '~/pages/Dashboard';
import Cidade from '~/pages/Cidade';
import Incorporadora from '~/pages/Incorporadora';
import IncorporadoraNew from '~/pages/Incorporadora/IncorporadoraNew';
import IncorporadoraEdit from '~/pages/Incorporadora/IncorporadoraEdit';
import MotivoNew from '~/pages/Motivo';
import MotivoEdit from '~/pages/Motivo/MotivoEdit';
import Times from '~/pages/Times';
import TimesNew from '~/pages/Times/TimesNew';
import TimesEdit from '~/pages/Times/TimesEdit';
import User from '~/pages/User';
import UsersNew from '~/pages/User/UsersNew';
import UsersEdit from '~/pages/User/UsersEdit';
import Perfil from '~/pages/Perfil';
import Cadencia from '~/pages/Cadencia';
import CadenciaNew from '~/pages/Cadencia/CadenciaNew';
import CadenciaEdit from '~/pages/Cadencia/CadenciaEdit';
import Tentativas from '~/pages/Tentativas';
import TentativaEdit from '~/pages/Tentativas/TentativaEdit';
import Integracao from '~/pages/Integracao';
import IntegracaoNew from '~/pages/Integracao/IntegracaoNew';
import IntegracaoEdit from '~/pages/Integracao/IntegracaoEdit';
import Product from '~/pages/Product';
import ProductNew from '~/pages/Product/ProductNew';
import ProductEdit from '~/pages/Product/ProductEdit';
import Questionario from '~/pages/Questionario';
import QuestionarioEdit from '~/pages/Questionario/QuestionarioEdit';
import Resposta from '~/pages/Resposta';
import RespostaEdit from '~/pages/Resposta/RespostaEdit';
import Padrao from '~/pages/Padrao';
import Leads from '~/pages/Leads';
import LeadNew from '~/pages/Leads/LeadNew';
import LeadImport from '~/pages/Leads/LeadImport';
import Temperatura from '~/pages/Temperatura';
import TemperaturaNew from '~/pages/Temperatura/TemperaturaNew';
import TemperaturaEdit from '~/pages/Temperatura/TemperaturaEdit';
import Atendimento from '~/pages/Atendimento';
import AtendimentoNew from '~/pages/Atendimento/AtendimentoNew';
import NovoAtendimento from '~/pages/NovoAtendimento';
import Email from '~/pages/Email';
import ChatNew from '~/pages/ChatNew';
import Relatorio from '~/pages/Relatorio';
import RelatorioEmail from '~/pages/RelatorioEmail';
import Mensagem from '~/pages/Mensagem';
import MensagemCreate from '~/pages/Mensagem/MensagemCreate';
import MensagemEdit from '~/pages/Mensagem/MensagemEdit';
import Agendamento from '~/pages/Agendamento';
import Teste from '~/pages/Teste';
import WhatMensagem from '~/pages/WhatMensagem';
import WhatMensagemCreate from '~/pages/WhatMensagem/WhatMensagemCreate';
import RelatorioGerais from '~/pages/RelatorioGerais';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={Login} />
      <Route path="/recuperar" component={Forgot} />
      <Route path="/password" component={Password} />
      <Route path="/dashboard" component={Dashboard} isPrivate />
      {/* Rota de cidades */}
      <Route path="/cidades" component={Cidade} isPrivate isProvider />
      {/* Rotas da incorporadora */}
      <Route
        path="/incorporadora"
        component={Incorporadora}
        isPrivate
        isProvider
      />
      <Route
        path="/incorporadora-create"
        component={IncorporadoraNew}
        isPrivate
        isProvider
      />
      <Route
        path="/incorporadora-edit/:id"
        component={IncorporadoraEdit}
        isPrivate
        isProvider
      />
      {/* Rotas de cancelamento */}
      <Route
        path="/cancelamento/:id/create"
        component={MotivoNew}
        isPrivate
        isProvider
      />
      <Route
        path="/cancelamento/:id/edit/:motivoId"
        component={MotivoEdit}
        isPrivate
        isProvider
      />
      {/* Rotas do times */}
      <Route path="/times" component={Times} isPrivate isDiretor />
      <Route path="/times-create" component={TimesNew} isPrivate isDiretor />
      <Route path="/times-edit/:id" component={TimesEdit} isPrivate isDiretor />
      {/* Rotas do usuario */}
      <Route path="/user" component={User} isPrivate />
      <Route path="/user-create" component={UsersNew} isPrivate />
      <Route path="/user-edit/:id" component={UsersEdit} isPrivate />
      {/* Rota do perfil */}
      <Route path="/perfil" component={Perfil} isPrivate isUser />
      {/* Rota de Cadencia */}
      <Route path="/cadencia" component={Cadencia} isPrivate isProvider />
      <Route
        path="/cadencia-create"
        component={CadenciaNew}
        isPrivate
        isProvider
      />
      <Route
        path="/cadencia-edit/:id"
        component={CadenciaEdit}
        isPrivate
        isProvider
      />
      {/* Rotas de tentativas */}
      <Route
        path="/tentativa-create/:id"
        component={Tentativas}
        isPrivate
        isProvider
      />
      <Route
        path="/tentativa-edit/:idCad/tentativas/:idTent"
        component={TentativaEdit}
        isPrivate
        isProvider
      />
      {/* Rota de integracao */}
      <Route path="/integracao" component={Integracao} isPrivate isProvider />
      <Route
        path="/integracao-new"
        component={IntegracaoNew}
        isPrivate
        isProvider
      />
      <Route
        path="/integracao-edit/:id"
        component={IntegracaoEdit}
        isPrivate
        isProvider
      />
      {/* Rotas do produto */}
      <Route path="/produto" component={Product} isPrivate isDiretor />
      <Route
        path="/produto-create"
        component={ProductNew}
        isPrivate
        isDiretor
      />
      <Route
        path="/produto-edit/:id"
        component={ProductEdit}
        isPrivate
        isDiretor
      />
      {/* Rota do questionario */}
      <Route
        path="/questionario-create/:id"
        component={Questionario}
        isPrivate
        isDiretor
      />
      <Route
        path="/questionario-edit/:id/quizzes/:idQuizzes"
        component={QuestionarioEdit}
        isPrivate
        isDiretor
      />
      {/* Rotas de respostas */}
      <Route
        path="/resposta-create/:idProduct/quizz/:idQuizzes"
        component={Resposta}
        isPrivate
        isUser
      />
      <Route
        path="/resposta-edit/:idProduct/quizz/:idQuizzes/res/:id"
        component={RespostaEdit}
        isPrivate
        isUser
      />
      {/* Rotas de padroes */}
      <Route
        path="/padrao-create/:id"
        component={Padrao}
        isPrivate
        isProvider
      />
      {/* Rotas dos leads */}
      <Route path="/leads" component={Leads} isPrivate isUser />
      <Route path="/create-lead" component={LeadNew} isPrivate isUser />
      <Route path="/import-lead" component={LeadImport} isPrivate isUser />
      {/* Rota de temperatura */}
      <Route path="/temperatura" component={Temperatura} isPrivate isUser />
      <Route
        path="/temperatura-create"
        component={TemperaturaNew}
        isPrivate
        isUser
      />
      <Route
        path="/temperatura-edit/:id"
        component={TemperaturaEdit}
        isPrivate
        isUser
      />
      {/* Rota de atendimento */}
      <Route path="/atendimento" component={Atendimento} isPrivate isUser />
      <Route
        path="/atendimento-create/:id"
        component={AtendimentoNew}
        isPrivate
        isUser
      />
      <Route path="/atividades" component={NovoAtendimento} isPrivate />
      {/* Rota de email */}
      <Route path="/email-atendimento/:id" component={Email} isPrivate />
      {/* Rota do Bot */}
      <Route path="/chat" component={ChatNew} isPrivate isUser />
      {/* Rota de relatorio */}
      <Route path="/relatorio" component={Relatorio} isPrivate isUser />
      {/* Rota de relatorio de email */}
      <Route
        path="/relatorio-email"
        component={RelatorioEmail}
        isPrivate
        isUser
      />
      {/* Rotas de mensagem */}
      <Route path="/mensagem" component={Mensagem} isPrivate isUser />
      <Route
        path="/mensagem-create"
        component={MensagemCreate}
        isPrivate
        isUser
      />
      <Route
        path="/mensagem-edit/:id"
        component={MensagemEdit}
        isPrivate
        isUser
      />
      <Route
        path="/whatsapp/:whatsapp_id/mensagem/:id"
        component={WhatMensagem}
        isPrivate
        isUser
      />
      <Route
        path="/whatsapp/:whatsapp_id/mensagem-edit"
        component={WhatMensagemCreate}
        isPrivate
        isUser
      />
      {/* Rota de Agendamento multiplos */}
      <Route
        path="/agendamentos"
        component={Agendamento}
        isPrivate
        isProvider
      />

      {/* Rota de teste */}
      <Route path="/teste" component={Teste} isPrivate isProvider />
      {/* Rota 404 */}
      <Route path="/error" component={() => <h1>404</h1>} />

      {/* Rota de relatorios gerais */}
      <Route
        path="/relatorio-gerais"
        component={RelatorioGerais}
        isPrivate
        isProvider
      />
    </Switch>
  );
}
